// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.110.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.110.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: 'Roboto', sans-serif;
}

:root {
  --primaryColor: #EE5566;
  --primaryColorDark: #a73b47;
  --primaryColorLight: #f38894;
}

body {
  margin: 0;
  font-family: 'Roboto', sans-serif;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.react-datepicker-wrapper p {
  margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["* {\n  font-family: 'Roboto', sans-serif;\n}\n\n:root {\n  --primaryColor: #EE5566;\n  --primaryColorDark: #a73b47;\n  --primaryColorLight: #f38894;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Roboto', sans-serif;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.react-datepicker-wrapper p {\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
